import React from 'react';
import RadarChart from './RadarChart';
import { useI18n } from './i18n';

// Card list of food-wine pairing sheets. Props: pairings (API objects), onSelect(pairing).
function PairingList({ pairings, onSelect }) {
  const { t, tc, formatDate, formatNumber } = useI18n();
  if (pairings.length === 0) {
    return <div className="empty-state">{t('pairing.list.empty')}</div>;
  }

  return (
    <div className="sheets-list">
      <h2>{t('pairing.list.title')}</h2>
      <div className="cards">
        {pairings.map((p) => (
          <div key={p.id} className="card" onClick={() => onSelect(p)}>
            <div className="card-header">
              <h3>{p.dish_name}</h3>
            </div>
            <div className="card-body">
              <p className="area">{p.wine_name} {p.vintage || ''}</p>
              <div className="radar-mini">
                <RadarChart data={p} />
              </div>
              {p.pairing_outcome && (
                <div className={`pairing-badge-sm ${p.pairing_outcome.replace(/_/g, '-')}`}>
                  {tc('outcome', p.pairing_outcome)}
                </div>
              )}
              {p.score != null && (
                <div className="card-score-final">{formatNumber(p.score)}/10</div>
              )}
            </div>
            <div className="card-footer">
              {formatDate(p.tasting_date) || '—'} {p.taster ? `· ${p.taster}` : ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PairingList;
